{
  "en": "English",
  "ru": "Русский",
  "kk": "Қазақша",
  "uz": "O‘zbekcha",
  "ky": "Кыргызча",
  "tg": "Тоҷикӣ",
  "tk": "Türkmençe",
  "tr": "Türkçe"
}
